import {Box, Typography} from '@mui/material';

import {alignmentStatus} from '../../../../../layouts/theme/designSystem';

export interface Props {
  met: boolean;
  title: string;
  subtitle: string;
  isFirst?: boolean;
}

export const WorkforceProfileAlignmentSectionLabel = ({
  met,
  title,
  subtitle,
  isFirst = false,
}: Props) => {
  const dotColor = met ? alignmentStatus.metAccent : alignmentStatus.gapAccent;
  const titleColor = met ? alignmentStatus.metAccent : alignmentStatus.gapLabel;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mt: isFirst ? 1.25 : met ? 2.5 : 3.5,
        mb: 1.2,
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
      }}
    >
      <Box sx={{width: 8, height: 8, borderRadius: '50%', bgcolor: dotColor, flexShrink: 0}} />
      <Typography component='span' sx={{fontSize: 11, fontWeight: 500, color: titleColor}}>
        {title}
      </Typography>
      <Typography
        component='span'
        sx={{
          fontSize: 11,
          color: 'text.disabled',
          fontWeight: 400,
          textTransform: 'none',
          letterSpacing: 0,
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};
